/**
 * AI learning system — tracks coach corrections to generated sessions.
 * Stored in client.aiPreferences (max 20, FIFO).
 * Injected into the AI prompt so it learns from past feedback.
 */

const MAX_PREFS = 20;

export function addPreference(client, setClients, pref) {
  const entry = { ...pref, ts: Date.now() };
  setClients(p => p.map(c => {
    if (c.id !== client.id) return c;
    const prefs = [...(c.aiPreferences || []), entry].slice(-MAX_PREFS);
    return { ...c, aiPreferences: prefs };
  }));
}

export function buildPreferencesBlock(client) {
  const prefs = client.aiPreferences || [];
  if (!prefs.length) return "";

  const lines = prefs.map(p => {
    switch (p.type) {
      case "regen":
        return `- Régénération demandée : ${p.style}`;
      case "alt_chosen":
        return `- "${p.original}" remplacé par "${p.chosen}"${p.reason ? ` (${p.reason})` : ""}`;
      case "removed":
        return `- "${p.exercise}" supprimé par le coach`;
      case "added":
        return `- "${p.exercise}" ajouté manuellement par le coach`;
      default:
        return null;
    }
  }).filter(Boolean);

  if (!lines.length) return "";

  return `Apprentissage (corrections du coach sur les séances précédentes) :
${lines.join("\n")}
→ Tiens compte de ces préférences : évite les exercices supprimés, privilégie ceux ajoutés manuellement, adapte le style selon les régénérations passées.`;
}
